
<div class="ia-prompt-card-container" *ngIf="agent._id!=null">
    <div  class="ia-prompt-card">
        <div class="ia-response" *ngIf="(messages|async)?.length > 0">

            <ng-container *ngFor="let conv of messages|async; let i = index" >
            <div class="user-question right" *ngIf="conv.role === 'user'">
                <p [innerHTML]="sanitizer.bypassSecurityTrustHtml(iaService.convertTextToHtml(conv.text))">conv.text</p>
            </div>
            <div class="response-item left" *ngIf="conv.role === 'assistant'"> 
                <p [innerHTML]="sanitizer.bypassSecurityTrustHtml(iaService.convertTextToHtml(conv.text))"></p>
                <div class="feedback" *ngIf="!conv.welcomeMessage">
                    <button nz-button nzShape="circle" nzSize="small" [nzType]="conv.feedback =='up'? 'primary' : 'default'" (click)="sendFeedback(conv, false)"  nz-tooltip  [nzTooltipTitle]="'ia.positive'|translateTA">
                        <i nz-icon nzType="like" nzTheme="outline"></i>
                    </button>
                    <button nz-button nzShape="circle" nzSize="small" (click)="sendFeedback(conv, true)"  [nzType]="!conv.feedback =='down'? 'danger' : 'default'" nz-tooltip  [nzTooltipTitle]="'ia.negative'|translateTA">
                        <i nz-icon nzType="dislike" nzTheme="outline"></i>
                    </button>

                    <nz-modal
                        [(nzVisible)]="showModalFeedback"
                        [nzTitle]="'ia.feedback'|translateTA"
                        nzOkText="{{'ia.close'|translateTA}}"
                        nzCentered="true"
                        [nzOkLoading]="loadingFeedback"
                        nzCancelText="{{'ia.cancel'|translateTA}}"
                        (nzOnOk)="onOKFeedBack(conv)"
                        (nzOnCancel)="onCancelFeedback(conv)">
                            
                        <ng-container *nzModalContent>
                            <textarea nz-input rows="8" [(ngModel)]="conv.feedbackMessage" ></textarea>
                        </ng-container>
                    </nz-modal>

                </div>
                <div class="id-session" *ngIf="conv.welcomeMessage">
                    <span>{{sessionId}}</span>
                </div>
            </div>
            </ng-container> 
        </div>


        <!-- GIF de carregamento -->
        <div class="ia-loading" *ngIf="loading || initLoading">
            <img src="assets/image/ia.gif" alt="loading" class="loading-gif" />
        </div>

        <nz-divider nzPlain nzVariant="solid"></nz-divider>
        <!-- Campo de entrada -->
        <div class="ia-input-area">
            
                <input
                    nz-input
                    [(ngModel)]="userPrompt"
                    placeholder="{{'ia.workflow.flow.creator'|translateTA}}"
                    class="ia-textarea"
                    (keyup.enter)="enviarPrompt()"
                />
            
            <!-- Botão de envio -->
            <div class="ia-actions">
                <button
                    nz-button
                    nzType="primary"
                    [disabled]="!userPrompt || loading || initLoading || loadingAttach"
                    (click)="enviarPrompt()"
                >
                    <i nz-icon nzType="send" nzTheme="outline"></i>
                        {{'ia.send'|translateTA}}
                </button>

                <button nz-button nzType="default"  nz-tooltip  [nzTooltipTitle]="'ia.newsession'|translateTA" (click)="newSession()" >
                    <nz-icon nzType="plus" nzTheme="outline"></nz-icon>
                    <!--{{'ia.newsession'|translateTA}}-->
                </button>

                <button nz-button nzType="default"  nz-tooltip  [nzTooltipTitle]="'ia.context'|translateTA" (click)="openContext()" [nzDanger]="variables.length>0">
                    <nz-icon nzType="setting" nzTheme="outline" >
                    </nz-icon>
                </button>
            </div>
         </div>
         <div class="upload-container"> 
            <nz-upload
                        [nzCustomRequest]="customUpload"
                        [nzShowUploadList]="true"
                        nzType="drag"
                        [nzMultiple]="true"
                        [nzWithCredentials]="false"
                        [nzBeforeUpload]="beforeUpload"
                        nzListType="picture"
                        (nzChange)="onChangeFileList($event)"
                        [(nzFileList)]="fileList"
                    >
                        
                        <button nz-button>
                            <nz-icon nzType="upload" />
                            {{'ia.upload'|translateTA}}
                        </button>
            </nz-upload>
        </div>

    </div>
</div>




<nz-modal
  [(nzVisible)]="showModalContext"
  [nzTitle]="'ia.variables'|translateTA"
  nzOkText="{{'ia.close'|translateTA}}"
  nzCentered="true"
  [nzCancelText]="null"
  (nzOnOk)="closeContext()">

    <ng-container *nzModalContent>

        <nz-table [nzData]="variables || []" nzBordered #tableContextVariable class="tab-container" [nzPageSize]="3">
            <thead>
                <tr>
                    <th>{{'ia.key'|translateTA}}</th>
                    <th>{{'ia.value'|translateTA}}</th>
                    <th style="width: 80px;">{{'ia.actions'|translateTA}}</th>
                </tr>
            </thead>
                
            <tbody>
                <tr class="row-insert-table">
                    <td>
                        <input nz-input placeholder="{{'ia.newkey'|translateTA}}" (keydown.space)="$event.preventDefault()"  [(ngModel)]="newKeyVariable" [ngModelOptions]="{standalone: true}"/>
                    </td>
                    <td>
                        <input nz-input placeholder="{{'ia.newvalue'|translateTA}}" [(ngModel)]="newValueVariable" [ngModelOptions]="{standalone: true}"/>
                    </td>
                    <td>
                        <button nz-button nzType="primary" nzSize="small" (click)="addVariable()">
                            {{'ia.add'|translateTA}}
                        </button>
                    </td>
                </tr>
                <tr *ngFor="let item of tableContextVariable.data; let i = index">
                    <td>
                        <input
                        nz-input
                        [(ngModel)]="item.key"
                        [ngModelOptions]="{standalone: true}"
                        />
                    </td>

                    <td>
                        <input
                        nz-input
                        [(ngModel)]="item.value"
                        [ngModelOptions]="{standalone: true}"
                        />
                    </td>

                    <td>
                        <button nz-button nzDanger nzSize="small" (click)="removeVariable(i)">
                            {{'ia.remove'|translateTA}}
                        </button>
                    </td>
                </tr>
                
            </tbody>
        </nz-table>
        
    </ng-container>

</nz-modal>
